module.exports = __webpack_public_path__ + "static/img/icon05.4f12452f.png";